import { createSlice } from "@reduxjs/toolkit";
import { PartitionDataType } from "@emisgroup/cohort-builder-kit";
import { Reducer } from "./Reducer";
import { IInitialState } from "./Types";

const initialState: IInitialState = {
  artefacts: [],
  breadcrumbItems: [],
  parentData: {} as PartitionDataType,
  metaData: []
};

export const Slice = createSlice({
  initialState,
  name: "partition-reducer",
  reducers: Reducer,
});
